import { searchChatIntentDetectionQuery } from '@atlassian/search-client/intent-detection';

import { INTENT_TYPE } from '../constants';
import { type ConvergenceRemoteIntentOptions, type IntentResponse } from '../types';

/** Adapts the Search/Chat Knowledge Discovery service to the intent harness response. */
export const getInputIntentRemoteConvergence = async (
	input: string,
	options: ConvergenceRemoteIntentOptions,
): Promise<IntentResponse> => {
	const variables = {
		// This endpoint uses the ARI owner to authorize the product. The multi-site search helper can
		// return a product-agnostic platform ARI, which the intent-detection backend rejects.
		siteId: `ari:cloud:${options.primaryProduct}::site/${options.cloudId}`,
		query: input,
		locale: options.locale,
		modelVersion: options.model,
	};
	const response = await searchChatIntentDetectionQuery(variables, options);
	const result = response.data?.knowledgeDiscovery.searchChatIntentDetection;

	if (result?.__typename !== 'KnowledgeDiscoverySearchChatIntentDetectionSuccess') {
		throw new Error('Search/Chat intent detection returned an unsuccessful response');
	}

	// The backend returns no rule pattern. This adapter is only invoked for input left unresolved by
	// local rules, so the convergence design's `RESIDUAL` reason describes the route to this result.
	return {
		didMatch: true,
		type: result.decision === 'CHAT' ? INTENT_TYPE.CHAT : INTENT_TYPE.FPS,
		pattern: 'RESIDUAL',
		modelVersion: result.modelVersion,
	};
};
